import React from 'react'
import PropTypes from 'prop-types'

const ArrowSvg = (props) => {
    const { onClick, direction } = props;
    return (
        <button
            aria-label='next-prev-button'
            onClick={onClick}
            className={`absolute z-30 ${direction === 'next' ? 'right-[-30px]' : 'left-[-30px] rotate-180'} top-3`}
        >
            <svg width="20" height="19" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M-6.1207e-07 7.99996C-5.88884e-07 8.26517 0.105356 8.51953 0.292893 8.70706C0.480429 8.8946 0.734783 8.99996 0.999999 8.99996L12.586 8.99996L8.292 13.292C8.10423 13.4797 7.99874 13.7344 7.99874 14C7.99874 14.2655 8.10423 14.5202 8.292 14.708C8.47977 14.8957 8.73445 15.0012 9 15.0012C9.26555 15.0012 9.52023 14.8957 9.708 14.708L15.708 8.70796C15.8011 8.61507 15.875 8.50471 15.9254 8.38322C15.9758 8.26173 16.0018 8.13149 16.0018 7.99996C16.0018 7.86842 15.9758 7.73818 15.9254 7.61669C15.875 7.4952 15.8011 7.38485 15.708 7.29196L9.708 1.29196C9.52023 1.10418 9.26555 0.998696 9 0.998696C8.73445 0.998696 8.47977 1.10418 8.292 1.29196C8.10422 1.47973 7.99874 1.73441 7.99874 1.99996C7.99874 2.26551 8.10423 2.52018 8.292 2.70796L12.586 6.99996L0.999999 6.99996C0.734783 6.99996 0.480429 7.10531 0.292893 7.29285C0.105356 7.48039 -6.35256e-07 7.73474 -6.1207e-07 7.99996Z" fill="#d14829"></path>
            </svg>
        </button>
    )
}

ArrowSvg.propTypes = {
    onClick: PropTypes.func,
    direction: PropTypes.string
}

export default ArrowSvg